import { useState } from "react";

interface VideoPlayerProps {
  cover: string;
  title: string;
  duration: string;
}

export default function VideoPlayer({ cover, title, duration }: VideoPlayerProps) {
  const [tip, setTip] = useState(false);
  const [playing, setPlaying] = useState(false);

  const onClickPlay = () => {
    setPlaying((v) => !v);
    setTip(true);
    window.setTimeout(() => setTip(false), 2600);
  };

  return (
    <div className="relative w-full aspect-video rounded-xl overflow-hidden bg-foreground-950 group">
      <img
        src={cover}
        alt={title}
        title={`${title} - 快手视频播放器演示`}
        className="w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-foreground-950/45"></div>

      <button
        type="button"
        onClick={onClickPlay}
        className="absolute inset-0 flex items-center justify-center cursor-pointer"
        aria-label="播放"
      >
        <span className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-background-50/90 flex items-center justify-center text-primary-600 text-3xl md:text-4xl group-hover:scale-110 transition-transform">
          <i className={playing ? "ri-pause-fill" : "ri-play-fill"}></i>
        </span>
      </button>

      <div className="absolute bottom-0 left-0 right-0 px-4 pb-4 pt-10 bg-gradient-to-t from-foreground-950/80 to-transparent">
        <div className="h-1 w-full rounded-full bg-background-50/30 overflow-hidden">
          <div className="h-full w-1/3 bg-primary-500"></div>
        </div>
        <div className="flex items-center justify-between mt-2 text-background-50 text-xs">
          <span className="flex items-center gap-1">
            <i className="ri-movie-2-line"></i>
            演示播放器
          </span>
          <span>{duration}</span>
        </div>
      </div>

      {tip && (
        <div className="absolute top-4 left-1/2 -translate-x-1/2 px-4 py-2 rounded-full bg-foreground-950/85 backdrop-blur text-background-50 text-xs md:text-sm animate-fade-in whitespace-nowrap">
          <i className="ri-information-line mr-1"></i>
          演示模式，暂不支持真实视频播放
        </div>
      )}
    </div>
  );
}